import React, { useEffect, useMemo, useState } from 'react';
import xtreamAPI from '../../api/xtreamAPI';
import { XtreamContent, XtreamCurrentLiveProgram } from '../../api/xtreamAPI';
import './EpgBar.css';

interface EpgBarProps {
  channel: XtreamContent | null;
}

const pad = (n: number) => String(n).padStart(2, '0');

const formatTime = (ms: number) => {
  const d = new Date(ms);
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const EpgBar: React.FC<EpgBarProps> = ({ channel }) => {
  const [program, setProgram] = useState<XtreamCurrentLiveProgram | null>(null);

  const streamId = useMemo(
    () => (channel ? String(channel.stream_id || '') : null),
    [channel]
  );

  useEffect(() => {
    if (!streamId) {
      setProgram(null);
      return;
    }

    let cancelled = false;
    setProgram(null);

    xtreamAPI
      .getLiveProgramSchedule(streamId, 12)
      .then((schedule) => {
        if (cancelled || !schedule.length) return;
        const now = Date.now();
        const current = schedule.find((p: any) => now >= p.startMs && now < p.endMs) ?? null;
        if (!cancelled) setProgram(current);
      })
      .catch(() => {
        // EPG não disponível para este canal
      });

    return () => {
      cancelled = true;
    };
  }, [streamId]);

  const channelName = channel?.name ?? '—';
  const startTime = program ? formatTime(program.startMs) : '—';
  const programTitle = program?.title ?? '—';

  return (
    <div className="epgbar">
      <span className="epgbar__text">
        <span className="epgbar__channel">{channelName}</span>
        {' '}
        <span className="epgbar__time">{startTime}</span>
        {' '}
        <span className="epgbar__program">{programTitle}</span>
      </span>
    </div>
  );
};
